import { USER_TYPES } from '../../constants/common';
import {
  IApplicantBinderDetails,
  IBillDetails,
  IBinderBill,
  IMemberBillingInfoRequest,
  IGpdMemberBillingInfoRequest,
} from '../../store/interface';
import utils, { IActiveMemberAPIHeaders, IAPIHeaders } from '../utils';

export interface IPaymentBillsHeaders extends IActiveMemberAPIHeaders {
  MPP_ID: number;
  STATE_CODE: string;
  MEMBER_ID: string;
}

export interface IBillDocumentHeaders {
  USER_TYPE_CODE: number;
  MPP_ID: number;
  MEMBER_ID: string;
}

export interface IBillDocumentData {
  selectedCim: string;
  selectedCase: string;
  billPeriod: string;
}

//interface IBillDocumentDetails {
//  billPeriod: string;
//  filePath: string;
//  processedDate: string;
//}
export interface IBillDocumentResponse {
  pdfStream: string;
}

export interface IBinderBillDetailsResponse {
  bills: IBinderBill[];
}
export interface IBinderBillsRequest {
  billRequests: IApplicantBinderDetails[];
}

export interface IPaymentManagerResponse {
  errorMessage: string;
  response: string;
}

export interface IPaymentManagerRequest {
  cims: Array<string>;
  previousAutopayEnabled: boolean;
}

const billing = () => ({
  getPaymentBills: (
    userTypeCode: number,
    headers: IPaymentBillsHeaders,
    data: IMemberBillingInfoRequest,
  ) => {
    return new Promise<IBillDetails>((resolve, reject) => {
      const { fetch, getUserSpecificAPIRoute } = utils;
      fetch(
        `${getUserSpecificAPIRoute(userTypeCode).billing.getPaymentBills}`,
        {
          method: 'POST',
          data,
          headers,
        },
      )
        .then((res: { response?: IBillDetails }) => {
          if (res && res.response && res.response.billDetails) {
            resolve(res.response);
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },

  getGovernmentMemberPaymentBills: (
    userTypeCode: number,
    headers: IPaymentBillsHeaders,
    data: IGpdMemberBillingInfoRequest,
  ) => {
    return new Promise<IBillDetails>((resolve, reject) => {
      const { fetch, getUserSpecificAPIRoute } = utils;
      fetch(
        `${
          getUserSpecificAPIRoute(userTypeCode).billing
            .getGovernmentMemberPaymentBills
        }`,
        {
          method: 'POST',
          data,
          headers,
        },
      )
        .then((res: { response?: IBillDetails }) => {
          if (res && res.response && res.response.billDetails) {
            resolve(res.response);
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getBinderBills: (
    userType: USER_TYPES,
    data: IBinderBillsRequest,
    headers: IAPIHeaders,
    isCABinder?: boolean,
  ) => {
    return new Promise<IBinderBillDetailsResponse>((resolve, reject) => {
      const { fetch, getUserSpecificAPIRoute } = utils;
      fetch(
        `${getUserSpecificAPIRoute(userType, isCABinder).billing.getBillInfo}`,
        {
          method: 'POST',
          data,
          headers,
        },
      )
        .then((res: { response?: IBinderBillDetailsResponse }) => {
          if (res && res.response && res.response.bills) {
            resolve(res.response);
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },
  getBillDocument: (headers: IBillDocumentHeaders, data: IBillDocumentData) => {
    return new Promise<IBillDocumentResponse>((resolve, reject) => {
      const { fetch, getUserSpecificAPIRoute } = utils;
      const { selectedCim, selectedCase, billPeriod } = data;
      const { USER_TYPE_CODE } = headers;

      fetch(
        `${
          getUserSpecificAPIRoute(USER_TYPE_CODE).billing.getBillDocument
        }?selectedCim=${selectedCim}&selectedCase=${selectedCase}&billPeriod=${billPeriod}`,
        {
          method: 'GET',
          data,
          headers,
        },
      )
        .then((res: { response?: IBillDocumentResponse }) => {
          if (res && res.response && res.response.pdfStream) {
			console.log("in getbilldocument");
            resolve(res.response);
          } else {
            const newResponse: IBillDocumentResponse = {
              pdfStream: '',
            };
            resolve(newResponse);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  convertToMppUser: (
    headers: IPaymentBillsHeaders,
    data: IPaymentManagerRequest,
  ) => {
    return new Promise<IPaymentManagerResponse>((resolve, reject) => {
      const { fetch, getUserSpecificAPIRoute } = utils;
      const { USER_TYPE_CODE } = headers;
      if (USER_TYPE_CODE) {
        fetch(
          `${
            getUserSpecificAPIRoute(USER_TYPE_CODE).billing.paymentManagement
          }`,
          {
            method: 'POST',
            data,
            headers,
          },
        )
          .then((res: { response?: IPaymentManagerResponse }) => {
            if (res && res.response) {
              resolve(res.response);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  },
});

export default billing;
